import React from 'react'

import Header from '../components/Header/header'
import Slider from '../components/Slider/slider-one'
import About from '../components/About/about'

import Features from '../components/Feature/features'
import VideoSection from '../components/VideoSection/videosection'
import Faq from "../components/Faq/faq";
import Download from '../components/DownloadSection/download'

import Footer from '../components/footer/footer'
import HowItWorks from '../components/HowItWorks/howItWorks'
import Screenshots from '../components/Screenshots/screenshots'

const Home = () => {
  return(
    <div>
      <div id="preloader">
        <div id="loader"></div>
      </div>
      <div id="main" className="main-content-wraper">
        <div className="main-content-inner">
          <Header />
          <Slider />
          <About />
          {/*<VideoSection imageData={"img/bg-wave-sym.png"} />
          <HowItWorks />
          <Features />
          <Faq />
          <Screenshots />*/}
          <Download />
          <Footer />
        </div>
      </div>
    </div>
  )
}

export default Home;